import { DatePipe } from '@angular/common';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ListLanguageFlagsComponent } from '../../components/list-language-flags/list-language-flags.component';
import { ItemRatingComponent } from '../../components/item-rating/item-rating.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import ServiceRestServices from '../../services/service-rest.service';
import RestService from '../../services/core-rest.service';
import CategoryService from '../../services/category.service';
import FetchingService from '../../services/fetching.service';
import UserService from '../../services/user.service';
import Session from '../../utils/session.service';
import DialogServices from '../../services/dialog.service';
import ModalService from '../../services/modal.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { ModalBookingEnquiryComponent } from '../../components/modal-booking-enquiry/modal-booking-enquiry.component';
import { ModalMediaComponent } from '../../components/modal-media/modal-media.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';

@Component({
	standalone: true,
	selector: 'specialist-details',
	templateUrl: './specialist-details.component.html',
	imports: [
		CommonModule, ModalMediaComponent, DatePipe, LowerCasePipe,
		TranslatePipe, ItemInfoPopoverComponent, AvatarComponent, 
		ListLanguageFlagsComponent, ItemRatingComponent, FormsModule,
		LoaderOverlayComponent
	]
})
export default class DoctorDetailsView implements OnInit {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private restService: RestService = inject(RestService);
	private categoryService: CategoryService = inject(CategoryService);
	private fetchingService: FetchingService = inject(FetchingService);
	private userService: UserService = inject(UserService);
	private session: Session = inject(Session);
	private dialogServices: DialogServices = inject(DialogServices);
	private modalService: ModalService = inject(ModalService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.hasIiziBusinessWallet = false;
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user.origin;
		this.vm.isSiffi = this.vm.origin == 'siffi.com';
		this.vm.isMinuDoc = this.vm.origin == 'minudoc.ee';
		this.vm.locale = (this.vm.user.deviceLanguage || 'et_EE').slice(0, 2);
		this.vm.sessionUserLanguage = this.vm.user.deviceLanguage;
		this.vm.charLimit = 180;
		
		this.vm.buttonTheme1 = (this.vm.user.origin == 'siffi.com' ? 'c-button--s2' : 'c-button--s1');
		this.vm.buttonTheme2 = (this.vm.user.origin == 'siffi.com' ? 'c-button--s11' : 'c-button--s6');
		this.vm.textColor = (this.vm.user.origin == 'siffi.com' ? '' : 'c-text--gray');
		
		this.vm.redirectToBooking = this.redirectToBooking;
		this.vm.redirect = this.redirect;
		this.vm.watchVideo = this.watchVideo;
		this.vm.openBookingEnquiry = this.openBookingEnquiry;
		this.vm.handleItemActive = this.handleItemActive;
		this.vm.handleItemInactive = this.handleItemInactive;
		this.vm.mobileBreakpoint = 1024;
		this.vm.getIconColor = this.getIconColor;
		this.handleParamsUpdate();
		this.vm.popoverStyle = [];
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.handleParamsUpdate(); });
		
		this.loadNetworkData();
	}
	
	loadNetworkData() {
		var promises: Array<any> = [];
		promises.push(this.getServiceDetails());
		promises.push(this.getTags());
		promises.push(this.getTherapies());
		
		this.angularHelperService.getPromise().all(promises).then((res) => {
			if (this.vm.service.tags) {
				this.vm.selectedTags = [];
				TAGS: for (var st = 0; st < this.vm.service.tags.length; st++) {
					for (var t = 0; t < this.vm.tagTranslations.length; t++) {
						if (this.vm.service.tags[st].tag.id === this.vm.tagTranslations[t].tag.id) {
							this.vm.selectedTags.push(this.vm.tagTranslations[t]);
							continue TAGS;
						}
					}
				}
			}
			if (this.vm.service.therapies) {
				this.vm.selectedTherapies = [];
				THERAPIES: for (var st = 0; st < this.vm.service.therapies.length; st++) {
					for (var t = 0; t < this.vm.therapyTranslations.length; t++) {
						if (this.vm.service.therapies[st].therapy.id === this.vm.therapyTranslations[t].therapy.id) {
							this.vm.selectedTherapies.push(this.vm.therapyTranslations[t]);
							continue THERAPIES;
						}
					}
				}
			}
			this.vm.initialized = true;
		});
	}
	
	getServiceDetails() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.serviceRestServices.getServiceById({ id: this.vm.serviceId },
			(service) => {
				this.vm.service = service || {};
				this.categoryService.getTranslation({
					subcategory: this.vm.service.subcategory,
					furtherSubcategory: this.vm.service.furtherSubcategory
				}).then((category) => {
					this.vm.category = category;
					this.initializeService();
					deferred.resolve();
				});
			},
			() => {
				deferred.reject();
			}
		);
		
		return deferred.promise;
	}
	
	getTags() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.restService.getServiceProviderTags({ language: this.vm.sessionUserLanguage })
			.then((tagTranslations) => {
				this.vm.tagTranslations = tagTranslations;
				deferred.resolve();
			})
			.catch((err) => {
				console.error(err);
				deferred.reject();
			});
		
		return deferred.promise;
	}
	
	redirect($event, link) {
		$event.preventDefault();
		window.open(link, '_blank');
	}
	
	watchVideo($event) {
		$event.preventDefault();
		this.vm.service.profileVideoPost.postType = 'VIDEO';
		this.modalService.openMedia(
			ModalMediaComponent,
			{
				media: this.vm.service.profileVideoPost,
				chat: {},
				modalId: 'modal-' + this.vm.service.profileVideoPost.id
			}
		);
	}

	getIconColor(type: 'video' | 'onsite'): string {
		const appointmentType = this.vm?.service?.typeOfAppointment;
		const origin = this.vm?.origin;
		const activeColor = origin === 'siffi.com' ? '#287638' : origin === 'minudoc.ee' ? '#004cdd' : 'rgba(208,203,203,0.46)';
		const grey = 'rgba(208,203,203,0.46)';

		if (type === 'video') {
			if (appointmentType === 'VIDEO_SESSION_ONLY' || appointmentType === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
				return activeColor;
			}
		} else if (type === 'onsite') {
			if (appointmentType === 'FACE_TO_FACE_SESSION_ONLY' || appointmentType === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
				return activeColor;
			}
		}

		return grey;
	}
	
	getTherapies() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.sessionUserLanguage || 'en_GB' } })
		.then((response) => {
			this.vm.therapyTranslations = response;
			deferred.resolve();
		});
		return deferred.promise;
	}
	
	openBookingEnquiry() {
		this.dialogServices.show({
			controller: ModalBookingEnquiryComponent,
			service: this.vm.service
		});
	}
	
	initializeService() {
		var d: any = moment(this.vm.service.nextAvailableTime).calendar().split(' ')[0];
		var currencies: any = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'PLN': 'zł', 'RUB': '₽', 'SEK': 'kr', 'DKK': 'kr.', 'NOK': 'kr' };
		
		this.vm.service.nextAvailableDate = (d === 'Today' || d === 'Tomorrow')
			? this.angularFilterHelperService.translate('Services.Time.' + d).toLowerCase()
			: this.angularFilterHelperService.formatDate(this.vm.service.nextAvailableTime, 'dd.MM.yy');
		this.vm.service.priceWithUnits = this.vm.service.pricing.price + currencies[this.vm.service.pricing.currency];
		this.vm.service.languages = this.vm.service.languagesSummary
			.split('·')
			.map((l) => { return l.trim(); })
			.filter((el, i, a) => { return i === a.indexOf(el); });
		this.vm.service.occupation = this.vm.category;
		this.vm.service.company = (this.vm.service.parentServiceTitle)
			? (', ' + this.vm.service.parentServiceTitle)
			: '';
		this.vm.service.license = (this.vm.service.licenseNumber)
			? this.angularFilterHelperService.translate('Subscription.Label.LicenseNumber') + ': ' + this.vm.service.licenseNumber
			: '';
		if (this.vm.service.descriptions) {
			var idx: any = -1;
			for (var i = 0, len = this.vm.service.descriptions.length; i < len; i++) {
				if (this.vm.service.descriptions[i].language === this.vm.locale && idx < 0) idx = i;
			}
			if (idx < 0) {
				// try to fall back to English
				for (var i = 0, len = this.vm.service.descriptions.length; i < len; i++) {
					if (this.vm.service.descriptions[i].language === 'en' && idx < 0) idx = i;
				}
			}
			if (idx >= 0) {
				this.vm.service.description = this.vm.service.descriptions[idx].description;
				this.vm.service.priceDisclaimer = this.vm.service.descriptions[idx].priceDisclaimer;
			}
		}
		
		this.vm.isServiceInitialized = true;
		this.handlePriceUpdate();
	}
	
	handlePriceUpdate() {
		this.userService.getWalletWithPrice(this.vm.service)
			.then((usedWallet) => {
				this.vm.isCoveredByBusinessWallet = (!usedWallet.price || usedWallet.coPayWallet) && this.vm.service.pricing.price;
				if (usedWallet.alternative) {
					if (usedWallet.coPayWallet) {
						this.vm.walletName = usedWallet.coPayWallet.wallet.name;
						this.vm.insuranceCoPay = true;
					} else {
						this.vm.walletName = usedWallet.wallet.name;
					}
				}
				this.vm.isInitialized = this.vm.isServiceInitialized;
			})
			.catch(() => {
				this.vm.isInitialized = this.vm.isServiceInitialized;
			});
	}
	
	openChatBotIntroduction(serviceId) {
		this.angularRoutingHelperService.setPath(['/chatbot', serviceId]);
	}
	
	redirectToBooking() {
		var storage: any = window.sessionStorage;
		var booking: any = { service: this.vm.service.id };
		
		this.vm.params = this.angularRoutingHelperService.getQueryParams();
		if (this.vm.params['coachingTopics']) {
			this.fetchingService.get('COACHING_TOPICS', { params: { language: this.vm.user.deviceLanguage || 'en_GB' } })
				.then((response) => {
					var coachingTopics: any = response;
					var selectedCoachingTopics: any = "" + this.vm.params['coachingTopics'];
					var coachingTitles: any = "";
					for (var i = 0; i < coachingTopics.length; i++) {
						if (selectedCoachingTopics.indexOf(coachingTopics[i].id) > -1
							&& (coachingTitles.length + coachingTopics[i].title.length) < 300) {
							if (coachingTitles) {
								coachingTitles += ", ";
							}
							coachingTitles += coachingTopics[i].title;
						}
					}
					booking.comment = coachingTitles;

					storage.setItem('booking', JSON.stringify(booking));
					this.angularRoutingHelperService.clearQueryParamsDirty();
					this.angularRoutingHelperService.setPath(['/booking/service', this.vm.service.id]);
				});
		} else {
			storage.setItem('booking', JSON.stringify(booking));
			this.angularRoutingHelperService.clearQueryParamsDirty();
			this.angularRoutingHelperService.setPath(['/booking/service', this.vm.service.id]);
		}
	}
	
	handleItemActive($event, index, isMouseMoveEvent) {
		$event.preventDefault();
		if (!this.vm.isMobileView && !isMouseMoveEvent) {
			return;
		}
		this.vm.showTherapyDescription = index;
		var rect: any = $event.target.getBoundingClientRect();
		this.vm.popoverStyle[index] = {
			top: rect.bottom + 'px',
			left: rect.left + 'px'
		};
	}
	
	handleItemInactive() {
		this.vm.showTherapyDescription = null;
	}
	
	handleParamsUpdate() {
		this.vm.isMobileView = window.innerWidth <= this.vm.mobileBreakpoint;
	}
	
}
